// @flow

import React from 'react';
import { colors } from 'seedling/constants';

type Props = {
  size: string,
};

function CircleSkipIcon({ size = '20' }: Props) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10c0 5.523 4.477 10 10 10s10-4.477 10-10S15.523 0 10 0 0 4.477 0 10zm18.857 0a8.857 8.857 0 11-17.714 0 8.857 8.857 0 1117.714 0z"
        fill={colors.lightYellow}
      />
      <path
        d="M13.866 9.81H5.991a.567.567 0 00-.562.57c0 .316.251.572.562.572h7.875c.31 0 .563-.255.563-.571a.567.567 0 00-.563-.571z"
        fill={colors.lightYellow}
      />
    </svg>
  );
}

export default CircleSkipIcon;
